import React from "react";
import { Link } from "react-router-dom";
import { Box } from "rizzui/box";
import { Button } from "rizzui/button";
import { Text, Title } from "rizzui/typography";
import EmptyState from "../../component/emptyState";

export default function BlankPage() {
  return (
    <div className="h-full justify-center xl:pl-[345px] xl:justify-start flex flex-row items-center">
      <EmptyState
        heading="No calls yet"
        subHeading="Calls made from leads will appear here, create a new campaign to get started"
      />
    </div>
  );
}
